import axios from 'axios';

import { getAccessToken } from 'src/app/auth/auth';
import { UserService } from 'src/app/auth/user-service';
import { getLocale } from 'src/packages/language/utils';

import { API_USER_FILES_URL } from './consts';

const userFileGenerationAgent = axios.create({
  baseURL: API_USER_FILES_URL + '/v2',
  headers: {
    'content-type': 'application/json',
  },
});

userFileGenerationAgent.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      const accessToken = await UserService.updateToken();

      if (error?.config && accessToken) {
        return axios.request({
          ...error.config,
          headers: {
            ...error.config.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        });
      }
    }

    return Promise.reject(error);
  }
);

userFileGenerationAgent.interceptors.request.use((config) => {
  const accessToken = getAccessToken();

  config.headers.set('accept-language', getLocale());

  if (accessToken) {
    config.headers.set('Authorization', `Bearer ${accessToken}`);
  }

  return config;
});

export { userFileGenerationAgent };
